import { Component } from '@angular/core';

@Component({ template: '<mat-spinner [diameter]="48"></mat-spinner>' })
export class EpdkLoadingDialogComponent { }